import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { DEFAULT_ICON_SIZE, DEFAULT_STROKE_WIDTH } from './types.js';
/**
 * The shared `<svg>` wrapper every icon renders.
 *
 * Defaults are baked in here so individual icon files stay tiny:
 *   - 24x24 viewBox (matches Lucide / Heroicons / Phosphor regular)
 *   - `currentColor` fill (icons inherit the surrounding text color)
 *   - stroke-based geometry with round caps + joins
 *   - aria-hidden by default — pass `aria-label` via IconProps to opt in to
 *     a meaningful accessible name
 *
 * Every icon file does:
 *
 *   export const Something = forwardRef<SVGSVGElement, IconProps>(
 *     (props, ref) => <IconBase ref={ref} {...props}>{paths}</IconBase>,
 *   );
 *
 * keeping the icon files to a one-liner of geometry.
 *
 * @example
 *   <IconBase size={32} strokeWidth={2}>
 *     <path d="M5 12h14M13 5l7 7-7 7" />
 *   </IconBase>
 */
export const IconBase = forwardRef(function IconBase({ size = DEFAULT_ICON_SIZE, color = 'currentColor', strokeWidth = DEFAULT_STROKE_WIDTH, fill = 'none', width, height, 'aria-hidden': ariaHidden, role, children, ...rest }, ref) {
    return (_jsx("svg", { ref: ref, xmlns: "http://www.w3.org/2000/svg", width: width ?? size, height: height ?? size, viewBox: "0 0 24 24", fill: fill, stroke: color, strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": ariaHidden ?? (role !== 'img' && rest['aria-label'] === undefined), role: role, ...rest, children: children }));
});
//# sourceMappingURL=IconBase.js.map